var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import classNames from "classnames";
import { nameToId } from "../utils/nameToId";
import { SwitchSize, SwitchStyle } from "./types";
const Switch = (_a) => {
    var { autoFocus, checked, className, disabled = false, id, name, onClick, onChange, size = SwitchSize.Medium, styling = SwitchStyle.Round, "aria-label": ariaLabel } = _a, props = __rest(_a, ["autoFocus", "checked", "className", "disabled", "id", "name", "onClick", "onChange", "size", "styling", "aria-label"]);
    // Inner checked state, only to use if not controlled externally through the checked prop
    // Kept for backward compatibility purpose
    const [chk, setCheck] = useState(checked || false);
    const checkedValue = checked !== undefined ? checked : chk;
    const classes = classNames("gerudo-switch", size, className, { disabled });
    id = id || nameToId(name);
    return (React.createElement("div", Object.assign({ className: classes }, props),
        React.createElement("input", { "aria-checked": checkedValue, "aria-label": ariaLabel, autoFocus: autoFocus, checked: checkedValue, disabled: disabled, id: id, role: "switch", name: name, onChange: (e) => {
                setCheck(!chk);
                if (onChange) {
                    onChange(e);
                }
            }, onClick: onClick, type: "checkbox" }),
        React.createElement("span", { className: `slider ${styling}` })));
};
export default Switch;
export { Switch };
//# sourceMappingURL=index.js.map